<template>
  <div class="container-fluid footer-style content-center">
    <div class="row justify-content-center">
      <div class="col-12 content-center text-center">
          <img src="/assets/images/logo-2.png" class="width-140" alt="">
        <!-- <div class="text-center width-100">
        </div> -->
      </div>
      <div class="col-12 text-center">
        <ul class="navbar-nav ul-style justify-content-center pt-2">
          <li class="nav-item btn_share">
            <router-link to="/" class="active" aria-current="page">{{t('footer.title_4')}}</router-link>
          </li>|
          <li class="nav-item">
            <router-link to="/aboutus">
            <span class=" text-white space">{{t('footer.title_3')}}</span>
            </router-link>
          </li>|

          <li class="nav-item d-none d-md-block">
            <router-link to="/contactUs">
              <span class=" text-white space">{{t('footer.contactUs')}}</span>
            </router-link>
          </li><span class="d-none d-md-block">|</span>
          
          <li class="nav-item d-none d-md-block">
            <router-link to="/terms">
              <span class=" text-white space">{{t('footer.title_6')}}</span>
            </router-link>
          </li>
          <span class="d-none d-md-block">|</span>

          <li class="nav-item d-none d-md-block">
            <router-link to="/privacyPolicy">
              <span class=" text-white space">{{t('footer.privacyPolicy')}}</span>
            </router-link>
          </li><span class="d-none d-md-block">|</span>

          <!-- <li class="nav-item d-none d-md-block">
            <router-link to="/contactUs">
              <span class=" text-white space">{{t('footer.contactUs')}}</span>
            </router-link>
          </li>| -->

          <li class="nav-item d-none d-md-block">
            <router-link to="/complaints">
              <span class=" text-white space">{{t('footer.complaints')}}</span>
            </router-link>
          </li><span class="d-none d-mb-block">|</span>
          <li class="nav-item d-block d-md-none">
            <router-link to="/contactUs">
              <span class=" text-white space">{{t('footer.contactUs')}}</span>
            </router-link>
          </li>
        </ul>
        <ul class="d-md-none navbar-nav follow text-Al-muhaisni pt-2">
          <!-- <h5 class="m-0 d-md-none space">{{t('footer.title_1')}}</h5> -->
          <li class="nav-item">
            <router-link to="/complaints">
              <span class=" text-white space">{{t('footer.complaints')}}</span>
            </router-link>
          </li><span class="d-block d-mb-none">|</span>

          <li class="nav-item">
            <router-link to="/terms">
              <span class=" text-white space">{{t('footer.title_6')}}</span>
            </router-link>
          </li>|

          <li class="nav-item d-block d-md-none m-0">
            <router-link to="/privacyPolicy">
              <span class=" text-white space">{{t('footer.privacyPolicy')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 col-md-6 content-center d-none d-md-block">
        <div class="text-Al-muhaisni">{{t('footer.title_2')}}</div>
      </div>
      <div class="col-12 col-md-6 media content-center pt-2 footer-padding">
        <!-- <h5 class="m-0 d-none d-md-block followHere">{{t('footer.title_1')}}</h5> -->
        <div class="row socialMediaFooter">
          <div class="col-auto">
            <a  href="https://www.tiktok.com/@amaqaria" target="_blank" rel="noopener noreferrer">
            <img class="tiktok" src="/assets/images/icons/tiktok-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <span class="">
              <a href="https://www.snapchat.com/add/almuhaysini_sa" target="_blank" rel="noopener noreferrer">
              <img class="snapchat" src="/assets/images/icons/Snapchat-w.png"  alt="">
              </a>
            </span>
          </div>
          <div class="col-auto">
            <span class="">
              <a href="https://www.youtube.com/@amaqaria" target="_blank" rel="noopener noreferrer">
              <img class="youtube" src="/assets/images/icons/Youtube-w.png"  alt="">
              </a>
            </span>
          </div>
          <div class="col-auto">
            <span class="">
              <a href="https://x.com/amaqaria" target="_blank" rel="noopener noreferrer">
              <img class="twitter" src="/assets/images/icons/twiter-w.png"  alt="">
              </a>
            </span>
          </div>
          <div class="col-auto">
            <span class="">
              <a href="https://www.instagram.com/amaqaria" target="_blank" rel="noopener noreferrer">
              <img class="instagram" src="/assets/images/icons/instagram-w.png"  alt="">
              </a>
            </span>
          </div>
          <div class="col-auto">
            <span class="">
              <a href="https://www.facebook.com/Amaqaria" target="_blank" rel="noopener noreferrer">
              <img class="facebook" src="/assets/images/icons/facebook-w.png"  alt="">
              </a>
            </span>
          </div>
          <div class="col-auto">
            <a  href="https://www.linkedin.com/company/%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9-%D8%A3%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D9%85%D8%AD%D9%8A%D8%B3%D9%86%D9%8A-%D8%A7%D9%84%D8%B9%D9%82%D8%A7%D8%B1%D9%8A%D8%A9/?viewAsMember=true" target="_blank">
              <img class="linkedin" src="/assets/images/icons/linkedin-w.png"  alt="">
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-block d-md-none">
        <div class="text-Al-muhaisni">{{t('footer.title_2')}}</div>
      </div>
    </div>
  </div>
  
</template>

<script setup> 
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n({ useScope: 'global' });
</script>

<script>
export default {
  name: "FooterBar",
}
</script>
<style scoped>
  .margin-t {
    margin-top: 50px;
  }
</style>